import { FC, useEffect, useState } from "react";
import { getTimeQuery } from "../../utils/Chromia/queries";


const PingPage: FC = () => {

	const [time, setTime] = useState('');

	useEffect(() => {
		getData()
	}, [])

	const getData = async () => {
		console.log('getData');
		setTime( (await getTimeQuery()) + '');
	}


	return (
		<div className="PingPage">
			<span>Time: {time}</span>
		</div>
	)
}

export default PingPage;